module.exports = __webpack_public_path__ + "static/gardening-464199e1132ca0827fbb4f93389d3ad9.png";